// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/banner-blue-small-item/banner-blue-small-item.component.scss
// module id = 122
// module chunks = 0